import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoCliente from "../../catalogos/catalogoCliente";

export const ActualizarMoviles = (props) => {

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbCedula = ["J", "V", "G", "P"];
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [visible, setVisible] = useState(false);
  const [activate, setActivate] = useState(false);
  const txtIdcliente = useRef();
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtObserStatus = useRef();
  const txtDireccionRespon = useRef();
  const txtNumContac = useRef();
  const txtSerialCa = useRef();
  const txtSerialMt = useRef();
  const txtPeso = useRef();
  const cmbCedularespon = ["J", "V", "G", "P"];
  const cmbRifrespon = useRef();
  const txtCedulaPro = useRef();
  const txtNombrePro = useRef();
  const txtNumPro = useRef();
  const txtDireccionPro = useRef();
  const txtNumPuesto = useRef();
  const txtTipoVh = useRef();
  const txtMarcaVh = useRef();
  const txtAnioVh = useRef();
  const txtValorVh = useRef();
  const txtModeloVh = useRef();
  const txtId = useRef();
  const cmbRif = useRef();
  const txtPlacaVh = useRef();
  const txtClaseVh = useRef();
  const txtCheck = useRef();
  const txtUsoVh = useRef();
  const txtColorVh = useRef();
  const txtCapCarga = useRef();
  const txtFechaIns = useRef();
  const [anio, setAnio] = useState([]);
  const [body, setBody] = useState(null);
  const [bloquear, setBloquear] = useState('colorbloqueado');
  const [fechas, setFechas] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [catalogoModelo, setCatalogoModelo] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);


  let token = sessionStorage.getItem('jwtToken');
  let op = require('../../../public/modulos/datos');
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));

  const onChange = (event) => {


  };


  const onCheck = () => {

    if (txtCheck.current.checked) {
      txtCedula.current.value = txtCedulaPro.current.value;
      txtNombreRespon.current.value = txtNombrePro.current.value;
      txtDireccionRespon.current.value = txtDireccionPro.current.value;
      txtNumContac.current.value = txtNumPro.current.value;
      cmbRifrespon.current.value = cmbRif.current.value;
    } else {
      txtCedula.current.value = "";
      txtNombreRespon.current.value = "";
      txtDireccionRespon.current.value = "";
      txtNumContac.current.value = "";
    }
  }

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {

      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
        event.target.value = '0,00'
      }
      event.target.value = (formatoMonto(event.target.value));
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === '0' && char2 !== ',') {
        event.target.value = event.target.value.substring(1, event.target.value.legth);
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/servicios/actualizaromoviles/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Creado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Modificado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    var valido;
    if (event.which === 13 || typeof (event.which) === 'undefined') {


    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };


  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope !== 4) {
      if (txtObserStatus.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione el Estatus !",
          icono: "informacion",
        });
        sigue = false;
        txtObserStatus.current.focus();
      } else if (txtFechaIns.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione la Fecha !",
          icono: "informacion",
        });
        sigue = false;
        txtFechaIns.current.focus();
      } else if (txtCedulaPro.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione el Cliente !",
          icono: "informacion",
        });
        sigue = false;
        txtCedulaPro.current.focus();
      } else if (cmbRifrespon.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione el Tipo de Documento !",
          icono: "informacion",
        });
        sigue = false;
        cmbRifrespon.current.focus();
      } else if (txtCedula.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el N° de Cédula/RIF del Responsable!",
          icono: "informacion",
        });
        sigue = false;
        txtCedula.current.focus();
      } else if (txtNombreRespon.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el Nombre del Responsable !",
          icono: "informacion",
        });
        sigue = false;
        txtNombreRespon.current.focus();
      } else if (txtDireccionRespon.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca la Dirección del Responsable !",
          icono: "informacion",
        });
        sigue = false;
        txtDireccionRespon.current.focus();
      } else if (txtSerialCa.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el Serial de la Carroceria !",
          icono: "informacion",
        });
        sigue = false;
        txtSerialCa.current.focus();
      } else if (txtPeso.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ El Campo Peso no debe ir Vacio !",
          icono: "informacion",
        });
        sigue = false;
        txtPeso.current.focus();
      } else if (txtCapCarga.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ El Campo CAP(CARGA Tons) no debe ir Vacio !",
          icono: "informacion",
        });
        sigue = false;
        txtCapCarga.current.focus();
      } else if (txtSerialMt.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el Serial del Motor !",
          icono: "informacion",
        });
        sigue = false;
        txtSerialMt.current.focus();
      } else if (txtAnioVh.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ El Campo Año no debe ir Vacio !",
          icono: "informacion",
        });
        sigue = false;
        txtAnioVh.current.focus();
      } else if (txtMarcaVh.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ El Campo Marca no debe ir Vacio !",
          icono: "informacion",
        });
        sigue = false;
        txtMarcaVh.current.focus();
      } else if (txtModeloVh.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ El Campo Modelo no debe ir Vacio !",
          icono: "informacion",
        });
        sigue = false;
        txtModeloVh.current.focus();
      } else if (txtColorVh.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ El Campo Color no debe ir Vacio !",
          icono: "informacion",
        });
        sigue = false;
        txtColorVh.current.focus();
      } else if (txtTipoVh.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ El Campo Tipo(Movil) no debe ir Vacio !",
          icono: "informacion",
        });
        sigue = false;
        txtTipoVh.current.focus();
      } else if (txtPlacaVh.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca la Placa del Movil !",
          icono: "informacion",
        });
        sigue = false;
        txtPlacaVh.current.focus();
      } else if (txtNumPuesto.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca la Cantidad de Puestos del Movil !",
          icono: "informacion",
        });
        sigue = false;
        txtNumPuesto.current.focus();
      } else if (txtUsoVh.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Describa el USO del Movil !",
          icono: "informacion",
        });
        sigue = false;
        txtUsoVh.current.focus();
      } else {
        sigue = true;
      }

      if (sigue) {

        let moviles = [];

        moviles.push({
          idmovil: txtId.current.value !== "" ? txtId.current.value : 0,
          idpropietario: txtIdcliente.current.value,
          nombrerespo: txtNombreRespon.current.value.trim(),
          cedularespo: cmbRif.current.value + txtCedula.current.value,
          direccionrespo: txtDireccionRespon.current.value.trim(),
          telefonorespo: txtNumContac.current.value,
          celularrespo: txtNumContac.current.value,
          serialcarroceria: txtSerialCa.current.value,
          serialmotor: txtSerialMt.current.value,
          placa: txtPlacaVh.current.value,
          marca: txtMarcaVh.current.value.trim(),
          modelo: txtModeloVh.current.value.trim(),
          anio: txtAnioVh.current.value,
          color: txtColorVh.current.value,
          uso: txtUsoVh.current.value,
          numpuesto: txtNumPuesto.current.value,
          peso: txtPeso.current.value.trim().replace(".", "").replace(",", "."),
          capacidadcarga: txtCapCarga.current.value.trim().replace(".", "").replace(",", "."),
          tipovehiculo: txtTipoVh.current.value.trim(),
          fecharegistro: txtFechaIns.current.value,
          status: txtObserStatus.current.value,
        });

        setBody({
          moviles: moviles,
        });

        let msg = "";
        if (operacion === 1) {
          msg = "Esta Seguro de Procesar este Registro.";
        } else if (operacion === 2) {
          msg = "Esta Seguro de Modificar este Registro.";
        } else if (operacion === 3) {
          msg = "Esta Seguro de Eliminar este Registro.";
        }

        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      }
    }
  };

  const blanquear = () => {
    setVisible(false);
    setMostrar1(false);
    setActivate(false);
    setDeshabilitado(false);
    setTabIndex(0);
    setFechas([]);
    setOperacion(0);
    setMsg('');
    setOperacion(0);
  }

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancelar();
    //props.onRenderizar();
  }

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    if (props.ope === 3 || props.ope === 2) {
      props.onHideCancelaDos();
    } else {
      props.onRenderizar();
    }
  };

  const onCatalogoCliente = (values) => {
    setCatalogoModelo(false);
    txtCedulaPro.current.value = values.rif.substring(1, 12);
    txtNombrePro.current.value = values.nombre;
    txtDireccionPro.current.value = values.direccion;
    txtNumPro.current.value = values.celular;
    txtIdcliente.current.value = values.idagente;
    cmbRif.current.value = values.rif.substring(0, 1);
  };

  const seleccionarCliente = (id, oper) => {
    let campos = "idagente, trim(nombre) as nombre, trim(direccion) as direccion, rif, celular";
    let nomtab = "agente";
    let nomid = "";

    if (oper === 2) {
      nomid = 'rif';
    } else {
      nomid = 'idagente';
    }

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idagente > 0) {
            txtCedulaPro.current.value = response.data.rif.substring(1, 12);
            txtNombrePro.current.value = response.data.nombre;
            txtDireccionPro.current.value = response.data.direccion;
            txtNumPro.current.value = response.data.celular;
            cmbRif.current.value = response.data.rif.substring(0, 1);
            if (oper === 2 || props.ope === 5) {
              txtIdcliente.current.value = response.data.idagente;
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        seleccionarCliente(rif, 2);
      }
    }
  };

  useEffect(() => {

    if (props.data.length > 0) {
      let i;
      let years = [];

      for (i = moment(fechasistema).format('YYYY'); i >= moment(fechasistema).format('YYYY') - 40; i--) {
        years.push(i);
      }
      setFechas(years);
    } else {
      let i;
      let years = [];

      for (i = moment(fechasistema).format('YYYY'); i >= moment(fechasistema).format('YYYY') - 40; i--) {
        years.push(i);
      }
      setFechas(years);
    }

  }, [props.data]);

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.ope !== 1) {
          if (props.ope === 5) {
            setOperacion(1);
            seleccionarCliente(props.data[0].idpropietario, 1);
            setTabIndex(props.data[0].idpropietario);
          } else {
            setOperacion(props.ope);
            seleccionarCliente(props.data.idpropietario, 1);
            txtPeso.current.value = formatMoneda(props.data.peso.toString().replace(",", "").replace(".", ","), ",", ".", 2);
            txtCapCarga.current.value = formatMoneda(props.data.capacidadcarga.toString().replace(",", "").replace(".", ","), ",", ".", 2);
            txtFechaIns.current.value = moment(props.data.fecharegistro).format('YYYY-MM-DD');
            txtCedula.current.value = props.data.cedularespo.substring(1, 12).trim();
            txtNombreRespon.current.value = props.data.nombrerespo.trim();
            txtDireccionRespon.current.value = props.data.direccionrespo.trim();
            txtNumContac.current.value = props.data.celularrespo !== null ? props.data.celularrespo.trim() : 0;
            txtSerialCa.current.value = props.data.serialcarroceria.trim();
            txtSerialMt.current.value = props.data.serialmotor.trim();
            txtAnioVh.current.value = props.data.anio;
            txtMarcaVh.current.value = props.data.marca.trim();
            txtModeloVh.current.value = props.data.modelo.trim();
            txtColorVh.current.value = props.data.color.trim();
            txtTipoVh.current.value = props.data.tipovehiculo.trim();
            txtPlacaVh.current.value = props.data.placa.trim();
            txtNumPuesto.current.value = props.data.numpuesto;
            txtUsoVh.current.value = props.data.uso.trim();
            txtIdcliente.current.value = props.data.idpropietario;
            cmbRifrespon.current.value = props.data.cedularespo.substring(0, 1).trim();
            setTabIndex(props.data.idmovil);
          }
        } else {
          setOperacion(props.ope);
          let i;
          let years = [];

          for (i = moment(fechasistema).format('YYYY'); i >= moment(fechasistema).format('YYYY') - 40; i--) {
            years.push(i);
          }
          setFechas(years);
        }

      }}

    >
      <Modal.Header className='azulGradiant' style={{ height: '40px' }}>
        <div style={{ color: "#fff" }}>{props.ope === 1 ? 'Agregar Móvil.' : props.ope === 2 ? 'Editar Móvil.' : props.ope === 3 ? 'Eliminar Móvil.' : 'Consultar Móvil.'}</div>
        <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <CatalogoCliente
          show={catalogoModelo}
          nomid={"cliente"}
          onHideCancelar={() => setCatalogoModelo(false)}
          onHideAceptaCatalogo={onCatalogoCliente}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>

        <div className='border-azul rounded mx-auto py-3 px-0'>
          <div className='container col-md-12 py-1'>
            <div className="container row m-0 px-0">
              <div className="input-group input-group-sm mb-1 col-md-2">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">CODIGO: </span>
                </div>
                <input type="text" disabled={true} ref={txtId} className="form-control" name='idvehiculo' defaultValue={props.data && props.data.idmovil} id="inputCodigo" />
              </div>

              <div className="input-group input-group-sm mb-1 col-md-2">
                <div className="input-group-prepend">
                  <span className="input-group-text">ESTATUS: </span>
                </div>
                <select disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} defaultValue={props.data && props.data.status} ref={txtObserStatus} className="form-control" id="inputStatus" name='status' onChange={onChange}>
                  <option value="">Seleccione</option>
                  <option value="0">ACTIVO</option>
                  <option value="1">INACTIVO</option>
                </select>
              </div>

              <div className="input-group input-group-sm mb-1 col-md-4">
                <div className="input-group-prepend">
                  <span className="input-group-text">FECHA REGISTRO: </span>
                </div>
                <input type="date" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtFechaIns} name='fechainscripcion' onChange={onChange} className="form-control col-md-5" id="inputFechaInscripcion" />
              </div>

            </div>
          </div>
          <div className='col-md-12 m-0 row mx-auto px-0 mb-1'>

            <div className='col-md-6 px-1'>
              <fieldset className='row col-md-12 col-12 border-azul rounded mx-auto'>
                <legend className="float-none w-auto mx-auto" >Datos del Propietario</legend>

                <div className="container row m-0 px-0">
                  <div className="input-group input-group-sm col-md-7 px-1 m-0 mb-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled={operacion === 4 || operacion === 3 || props.ope === 5 ? true : deshabilitado}
                      className="form-select form-select-sm col-md-3 text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--</option>
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtCedulaPro}
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 || props.ope === 5 ? true : deshabilitado}
                      maxLength={12}
                      type="text"
                      onKeyUp={validarCliente}
                      onBlur={validarCliente}
                      className="form-control fs-6 px-1"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button disabled={operacion === 4 || operacion === 3 || props.ope === 5 ? true : deshabilitado} type="button" onClick={() => setCatalogoModelo(true)} className="btn btn-success"><i className="fas fa-search"></i></button>
                    <input type="hidden" ref={txtIdcliente} />
                  </div>
                  <div className="input-group input-group-sm col-md-12 px-1 m-0 mb-1">
                    <div className="input-group-prepend">
                      <span className="input-group-text">APELLIDOS y NOMBRES:</span>
                    </div>
                    <input type="text" disabled={true} ref={txtNombrePro} className="form-control text-uppercase" name='nombrepropie' onChange={onChange} id="inputPropiet" />
                  </div>
                </div>
                <div className="container row m-0 px-0">
                  <div className="input-group input-group-sm col-md-12 px-1 m-0 mb-1">
                    <div className="input-group-prepend">
                      <span className="input-group-text">DIRECCION:</span>
                    </div>
                    <textarea type="textarea" style={{ height: 70 }} disabled={true} ref={txtDireccionPro} className="form-control text-uppercase" name='direccionpropie' onChange={onChange} id="inputDirecpropiet" />
                  </div>
                </div>
                <div className="container row m-0 px-0">
                  <div className="input-group input-group-sm col-md-6 px-1 m-0 mb-1">
                    <div className="input-group-prepend">
                      <span className="input-group-text">N° TELEFONO:</span>
                    </div>
                    <input type="text" disabled={true} maxLength='12' ref={txtNumPro} className="form-control col-md-5" name='telefonopropie' onChange={handleInputNumChange} id="inputTelefonopropie" />
                  </div>
                  <div className='col-md-2'></div>
                  <div className="col-md-4">
                    <div className="form-check">
                      <input className="my-auto form-check-input" disabled={operacion === 4 || operacion === 3 || operacion === 2 ? true : deshabilitado} ref={txtCheck} onChange={onCheck} type="checkbox" value="" id="flexCheckIndeterminate" />
                      <label className="my-auto form-check-label" for="flexCheckIndeterminate">
                        Responsable
                      </label>
                    </div>
                  </div>
                </div>

              </fieldset>
            </div>

            <div className='col-md-6 px-1'>
              <fieldset className='row col-md-12 col-12 border-azul rounded mx-auto'>
                <legend className="float-none w-auto mx-auto " >Datos del Responsable</legend>

                <div className="container row m-0 px-0">
                  <div className="input-group input-group-sm col-md-7 px-1 m-0 mb-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRifrespon}
                      name="cmbrif"
                      disabled={operacion === 4 || operacion === 3 ? true : deshabilitado}
                      className="form-select form-select-sm col-md-3 text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--</option>
                      {cmbCedularespon &&
                        cmbCedularespon.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtCedula}
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 ? true : deshabilitado}
                      maxLength={12}
                      type="text"
                      onKeyUp={validarCliente}
                      onBlur={validarCliente}
                      className="form-control fs-6 px-1"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm col-md-12 px-1 m-0 mb-1">
                    <div className="input-group-prepend">
                      <span className="input-group-text">APELLIDOS y NOMBRES:</span>
                    </div>
                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtNombreRespon} className="form-control text-uppercase" name='nombrerespo' onChange={onChange} id="inputNombrerespon" />
                  </div>
                </div>
                <div className="container row m-0 px-0">
                  <div className="input-group input-group-sm col-md-12 px-1 m-0 mb-1">
                    <div className="input-group-prepend">
                      <span className="input-group-text">DIRECCION:</span>
                    </div>
                    <textarea type="textarea" style={{ height: 70 }} disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtDireccionRespon} className="form-control text-uppercase" name='direccionrespo' onChange={onChange} id="inputDireccionrespon" />
                  </div>
                </div>
                <div className="container row m-0 px-0">
                  <div className="input-group input-group-sm col-md-6 px-1 m-0 mb-1">
                    <div className="input-group-prepend">
                      <span className="input-group-text">N° TELEFONO:</span>
                    </div>
                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} maxLength='11' ref={txtNumContac} className="form-control col-md-5" name='telefonorespo' onChange={handleInputNumChange} id="inputTelefrespon" />
                  </div>
                  <div className='col-md-6'></div>
                </div>

              </fieldset>
            </div>
          </div>
        </div>

        <fieldset className='row col-md-12 col-12 border-azul rounded mx-auto'>
          <legend className="float-none w-auto" >Datos del Vehículo</legend>

          <div className="container row m-0 px-0">
            <div className="input-group input-group-sm col-md-4 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">SERIAL(CARROCERIA): </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtSerialCa} className="form-control text-uppercase" name='serialcarroceria' onChange={onChange} id="inputSerialcarro" />
            </div>
            <div className="input-group input-group-sm col-pd-150 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">PESO: </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtPeso} className={`${operacion === 4 || operacion === 3 ? bloquear : deshabilitado} form-control`} name='peso' onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="inputPeso" />
            </div>
            <div className="input-group input-group-sm col-pd-230 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">CAP(CARGA Tons): </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtCapCarga} className={`${operacion === 4 || operacion === 3 ? bloquear : deshabilitado} form-control`} name='capacidadcarga' onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} id="inputcapacidadcarga" />
            </div>
            <div className="input-group input-group-sm col-pd-340 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">SERIAL(MOTOR): </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtSerialMt} className="form-control text-uppercase" name='serialmotor' onChange={onChange} id="inputSerialmotor" />
            </div>
          </div>

          <div className="container row m-0 px-0">
            <div className="input-group input-group-sm col-pd-110 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">AÑO: </span>
              </div>
              <select disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtAnioVh} className="form-control" id="inputStatus" name='anio'>
                {fechas &&
                  fechas.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
              </select>
            </div>
            {/* <div className="input-group input-group-sm col-pd-110 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">AÑO: </span>
              </div>
              <input type="date" maxLength={4} disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtAnioVh} className={`${operacion === 4 || operacion === 3 ? bloquear : deshabilitado} form-control`} name='anio' onChange={handleInputNumChange} id="inputanio" aria-label="Amount (to the nearest dollar)" />
            </div> */}
            <div className="input-group input-group-sm col-pd-220 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">MARCA: </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtMarcaVh} className="form-control text-uppercase" name='marca' onChange={onChange} id="inputMarca" />
            </div>
            <div className="input-group input-group-sm col-md-3 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">MODELO: </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtModeloVh} className="form-control text-uppercase" name='modelo' onChange={onChange} id="inputmodelo" />
            </div>
            <div className="input-group input-group-sm col-md-2 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">COLOR: </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtColorVh} className="form-control text-uppercase" name='color' onChange={onChange} id="inputColor" />
            </div>
            <div className="input-group input-group-sm col-pd-300 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">TIPO(Movil): </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtTipoVh} className="form-control text-uppercase" name='tipovehiculo' onChange={onChange} id="inputtipovehiculo" />
            </div>
          </div>

          <div className="container row m-0 px-0">
            <div className="input-group input-group-sm col-md-2 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">N° PLACA: </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtPlacaVh} className="form-control text-uppercase" name='placa' onChange={onChange} id="inputplaca" aria-label="Amount (to the nearest dollar)" />
            </div>
            <div className="input-group input-group-sm col-pd-130 px-1 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">PUESTOS: </span>
              </div>
              <input type="text" maxLength={2} disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtNumPuesto} className={`${operacion === 4 || operacion === 3 ? bloquear : deshabilitado} form-control`} name='numpuesto' onChange={handleInputNumChange} id="inputnumpuesto" aria-label="Amount (to the nearest dollar)" />
            </div>
            <div className="input-group input-group-sm col-pd-769  px-0 m-0 mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">USO: </span>
              </div>
              <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtUsoVh} className="form-control text-uppercase" name='uso' onChange={onChange} id="inputuso" />
            </div>
          </div>
        </fieldset>


      </Modal.Body >
      <Modal.Footer>
        <button ref={btnAcepta} disabled={operacion === 4 ? true : false} onClick={onChangeValidar} className="btn btn-success rounded-pill btn-sm"><i className="fas fa-check-circle">  Aceptar</i></button>
        <button ref={btnCancela} onClick={cancelar} className="btn btn-danger rounded-pill btn-sm"><i className="fas fa-window-close"> Cancelar</i></button>
      </Modal.Footer>
    </Modal >
  );
};
export default ActualizarMoviles;



// WEBPACK FOOTER //
// ./src/components/servicios/gestionarMoviles.js